import { crmApi } from '../crmApi';
import { AuthRequest, AuthResponse, AuthTokens } from './types';

// SERVICES USED TO MANAGE CACHING OF NETWORK REQUESTS
// RTK QUERY PROVIDES HOOKS FOR GETTING THE CURRENT STATUS OF A REQUEST
const DEV_URI = process.env.REACT_APP_AUTH_SERVICE
    ? `${process.env.REACT_APP_AUTH_SERVICE}`
    : '/authentication-service';

export const authApi = crmApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<AuthResponse, AuthRequest>({
            query: (credentials) => ({
                url: `${DEV_URI}/authenticate`,
                method: 'POST',
                body: {
                    username: credentials.username,
                    password: credentials.password,
                },
            }),
        }),
        refresh: builder.mutation<AuthResponse, Omit<AuthTokens, 'accessToken'>>({
            query: (refreshToken) => ({
                url: `${DEV_URI}/refreshToken`,
                method: 'POST',
                body: { refreshToken },
            }),
        }),
        googleLogin: builder.mutation<AuthResponse, string>({
            query: (tokenId) => ({
                url: `${DEV_URI}/oauth2/google?idTokenString=${tokenId}`,
                method: 'POST',
            }),
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLoginMutation, useGoogleLoginMutation } = authApi;
